import { env } from './EnvironmentConfig';

export const APP_NAME = 'Superpratico';
export const API_BASE_URL = env.API_ENDPOINT_URL;
